import { AutoComplete } from "antd";
import { Input } from "@chakra-ui/input";
import { Spinner } from "@chakra-ui/react";
import useCodigoImpostoAutoComplete from "core/features/Imposto/hooks/useCodigoImpostoAutoComplete";

export interface InputAutoCompleteCodigoImpostoProps {
  textValue: string | undefined;
  onType: (v: string | undefined) => any;
  placeholder?: string;
}

function InputAutoCompleteCodigoImposto({
  textValue,
  onType,
  placeholder = "Procurar",
}: InputAutoCompleteCodigoImpostoProps) {
  const { data, isLoading, isFetching } = useCodigoImpostoAutoComplete();

  const items =
    data?.map((item) => ({
      value: item.codigo,
      label: item.nome,
    })) || [];

  const _isLoading = isLoading || isFetching;

  return (
    <AutoComplete
      value={textValue}
      onChange={(v, option) => {
        onType(v);
      }}
      allowClear
      onClear={() => {
        onType(undefined);
      }}
      options={items}
      onSelect={(_, option) => {
        onType(option.value);
      }}
      bordered={false}
      backfill={false}
      filterOption
      searchValue={textValue}
      optionFilterProp="label"
      clearIcon={_isLoading ? <Spinner ml={-1.5} mt={-1.5} /> : undefined}
      style={{
        width: "100%",
      }}
    >
      <Input placeholder={placeholder} pr="48px" />
    </AutoComplete>
  );
}

export default InputAutoCompleteCodigoImposto;
